import {fadeIn, fadeOut} from "../../../default/global/js/utilities/fade";

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
    ));
}

function trapFocus(e, menu) {
    if (e.key !== 'Tab') return;
    const focusable = getFocusableElements(menu);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
        if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    } else {
        if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }
}

function buildChildrenBackLink() {
    let childrenBackLinks = document.querySelectorAll(".mobileMenu__backLink");
    for(let childrenBackLink of childrenBackLinks) {
        childrenBackLink.addEventListener("click", function (e) {
            e.preventDefault();
            const openParent = this.closest(".hasChildren.is-open");
            if (!openParent) return;
            openParent.classList.remove("is-open");
            const closestUl = openParent.querySelector("ul");
            if(closestUl){
                closestUl.scrollTop = 0;
                closestUl.style.overflow = "";
            }
        });
    }

}

function buildChildrenHeader(wrapper, childrenLink) {
    const childrenHeader = document.createElement("a");
    const li = document.createElement("li");
    li.appendChild(childrenHeader);

    childrenHeader.classList.add("mobileMenu__subHeader");
    childrenHeader.innerText = childrenLink.innerText;
    if (childrenLink.tagName === 'A') {
        childrenHeader.href = childrenLink.href;
    }

    wrapper.prepend(li);
}

function addClickEventMobileMenuLink(link) {
    let hasChildren = false;
    let childrenLink = false;
    let parent = link.closest("li");
    let childrenList = false;

    //Baustein
    if(link.parentElement.classList.contains("textcontent")) {
        return;
    }

    for (let children of parent.children) {
        if (children.tagName === "UL") {
            hasChildren = true;
            childrenList = children;
        }
        if (children.tagName === 'A' || children.tagName === 'SPAN') {
            childrenLink = children;
        }
    }

    if (hasChildren) {
        childrenLink.addEventListener("click", function (e) {
            let closestLi = childrenLink.closest('li');
            let closestUl = childrenLink.closest("ul");
            closestUl.scrollTop = 0;
            if (closestLi.classList.contains("is-open")) {
                closestLi.classList.remove("is-open");
                childrenLink.classList.remove("is-active");
                closestUl.style.overflow = "";
            } else {
                closestLi.classList.add("is-open");
                childrenLink.classList.add("is-active");
                closestUl.style.overflow = "hidden";
            }
            e.preventDefault();
        });

        parent.classList.add("hasChildren");
    }
}

export function buildMobileMenu(menu) {
    if (menu) {
        for(let menuNavigation of menu.querySelectorAll(".mobileMenu__navigation")){
            for (let link of menuNavigation.querySelectorAll('a')) {
                addClickEventMobileMenuLink(link);
            }
            for (let activeUl of menuNavigation.querySelectorAll('.is-active,.is-active-tree')) {
                activeUl.classList.add("is-open");
            }
        }
        buildChildrenBackLink();
    }
}

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("is-open");
        toggle.classList.add("is-active");
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add("is-mobilemenuopen");
        const firstFocusable = getFocusableElements(menu)[0];
        if (firstFocusable) firstFocusable.focus();
        menu._trapFocusHandler = (e) => trapFocus(e, menu);
        menu.addEventListener('keydown', menu._trapFocusHandler);
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove("is-mobilemenuopen");
    fadeOut(overlay);
    if (menu._trapFocusHandler) {
        menu.removeEventListener('keydown', menu._trapFocusHandler);
        menu._trapFocusHandler = null;
    }
    toggle.focus();
}